<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <form @submit.prevent>
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title">Marcação de Supervisão Clínica</p>
        </header>
        <section v-if="isPremium" class="modal-card-body">
          <b-field label="Nome">
            <b-input
              type="text"
              v-model="name"
              placeholder="Seu Nome Completo"
              required
            >
            </b-input>
          </b-field>

          <b-field label="Email">
            <b-input
              type="email"
              v-model="email"
              placeholder="Seu Email"
              required
            >
            </b-input>
          </b-field>

          <b-field label="Whatsapp">
            <b-input
              type="whatsapp"
              v-model="whatsapp"
              placeholder="Seu Whatsapp"
              required
            >
            </b-input>
          </b-field>

          <b-field label="Especialidade">
            <b-input
              v-model="specialty"
              placeholder="Especialidade desejada para os casos clínicos"
              required
            >
            </b-input>
          </b-field>

           <b-field label="Horário Preferencial">
            <b-input
              v-model="mainTime"
              placeholder=""
              required
            >
            </b-input>
          </b-field>

           <b-field label="Horário Alternativo 1">
            <b-input
              v-model="altTime1"
              placeholder=""
            >
            </b-input>
          </b-field>

          <b-field label="Horário Alternativo 2">
            <b-input
              v-model="altTime2"
              placeholder=""
            >
            </b-input>
          </b-field>

          <input
            type="text"
            name="catchBot"
            v-model="catchBot"
            style="display:none"
          >

          <input
            type="hidden"
            name="_captcha"
            value="false"
          >

        </section>
        <section v-else class="modal-card-body py-8" style="text-transform: none">
        <p>
          Este é um recurso exclusivo de usuários premium. Atualize seu plano e tenha acesso a este recurso
        </p>
      </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >Cancelar</button>
          <button
            v-if="isPremium"
            @click="sendMessage()"
            class="button is-primary"
          >Enviar</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import fetch from 'unfetch'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      performingRequest: false,
      name: '',
      email: '',
      whatsapp: '',
      specialty: '',
      mainTime: '',
      altTime1: '',
      altTime2: '',
      catchBot: ''
    }
  },
  mounted () {
    this.$store.dispatch('fetchPremiumStatus')
  },

  computed: {
    ...mapState([
      'isPremium'
    ])
  },
  methods: {
    sendMessage () {
      this.performingRequest = true

      const data = new URLSearchParams()

      data.append('Nome', this.name)
      data.append('Email', this.email)
      data.append('Whatsapp', this.whatsapp)
      data.append('Especialidade', this.specialty)
      data.append('Opção de Horário Preferencial', this.mainTime)
      data.append('Opção de Horário 1', this.altTime1)
      data.append('Opção de Horário 2', this.altTime2)
      data.append('_captcha', 'false')
      data.append('_honey', this.catchBot)
      data.append('_subject', 'Contato Spervisão Clínica')

      fetch('https://cors-anywhere.herokuapp.com/https://formsubmit.co/87e239abf283b4746ea4bb2f01ac5e31',
        {
          method: 'POST',
          body: data,
          headers:
            { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(data => {
          this.$toasted.success('Mensagem enviada com sucesso. Retornaremos o contato em breve!')
          this.$parent.close()
        })
        .catch(error => {
          console.error(error)
          this.$toasted.error('Não foi possível enviar sua mensagem. Tente novamente mais tarde')
        })
        .finally(() => {
          this.performingRequest = false
        })
    }
  }

}
</script>
